// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".video-stack_44b3 canvas {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/VideoStack.scss","VideoStack.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;EACA,WAAA;EACA,YAAA;ACAR","file":"VideoStack.scss","sourcesContent":[".video-stack {\n    canvas {\n        object-fit: cover;\n        width: 100%;\n        height: 100%;\n    }\n}\n",".video-stack canvas {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}"]}]);
// Exports
exports.locals = {
	"video-stack": "video-stack_44b3"
};
module.exports = exports;
